import {Compass} from 'lucide-react';
import {Typography} from "../ui/Typography";
import {Button} from "../ui/Button";
import { useNavigate } from "react-router-dom";


const pageNotFoundText = "Het lijkt erop dat de pagina die je zoekt is verplaatst, verwijderd of niet bestaat. " +
    "Laten we je weer op het juiste spoor zetten.";

export const NotFound404 = () => {
    const navigate = useNavigate();
    const handleToHomepageClick = () => {
        navigate("/");
    }

    return (
        <div className="flex flex-col">
            <main className="flex-grow">
                <section className="py-64">
                    <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <div className="relative flex flex-col items-center">

                            {/* 404 text */}

                            <div className="flex flex-col items-center mt-20 sm:-mt-24 md:-mt-32 gap-10">

                                <Compass size={100} className="text-ember-500" />

                                <Typography
                                    as="h1"
                                    variant="h1"
                                    className="tracking-tight text-ink-50"
                                >
                                    Pagina Niet Gevonden
                                </Typography>

                                <Typography as="p" variant="p" className="max-w-xl text-lg text-ink-300">
                                    {pageNotFoundText}
                                </Typography>

                                <Button
                                    intent="primary"
                                    size="medium"
                                    onClick={handleToHomepageClick}
                                >
                                    Terug naar de Homepage
                                </Button>

                            </div>
                        </div>

                    </div>
                </section>
            </main>
        </div>
    );
};

const Text404 = (any) => {
    return(
        <p
            aria-hidden="true"
            className="text-[10rem] sm:text-[12rem] md:text-[16rem] font-extrabold text-surface-900 leading-none"
        >
        </p>
    );
};



